import styled from '@emotion/styled'

import { theme } from '../../../../constants'
import { Flex } from '../../../../elements'

export const CellShiftsColumn = styled(Flex)({
  height: '100%',
  position: 'relative',
  alignItems: 'flex-start',
  gap: theme.spacing[1.5],
  flexDirection: 'column',
})
